export const hasDentalPlans = (quoteData: any): boolean => {
  try {
    return !!(quoteData?.crossSalePlans?.length || quoteData?.jsonPlans?.length)
  } catch {
    return false
  }
}

export const isPlanRecommended = (p: any): boolean => {
  try {
    const r1 = p?.producerRecommended
    const r2 = p?.recommended
    return (
      r1 === true ||
      r1 === 'y' ||
      r1 === 'Y' ||
      r2 === true ||
      r2 === 'y' ||
      r2 === 'Y'
    )
  } catch {
    return false
  }
}

export const collectAgentRecommendedPlans = (
  current: any
): Array<{ planId: string; plan: any }> => {
  const out: Array<{ planId: string; plan: any }> = []
  try {
    const visionPlans: any[] = Array.isArray(current?.individualPlans)
      ? (current as any).individualPlans
      : []
    const dentalPlans: any[] = Array.isArray(current?.crossSalePlans)
      ? (current as any).crossSalePlans
      : Array.isArray((current as any)?.jsonPlans)
        ? (current as any).jsonPlans
        : []
    for (const vp of visionPlans) {
      if (isPlanRecommended(vp)) {
        const id = (vp as any).id || (vp as any).planId
        if (id) {
          const planPayload = {
            ...(vp as any),
            recommended: 'y',
            show: 'y',
            planId: id,
          }
          out.push({ planId: id, plan: planPayload })
        }
      }
    }
    for (const dp of dentalPlans) {
      if (isPlanRecommended(dp)) {
        const id = (dp as any).planId || (dp as any).id
        if (id) {
          const planPayload = {
            ...(dp as any),
            recommended: 'y',
            show: 'y',
            planId: id,
          }
          out.push({ planId: id, plan: planPayload })
        }
      }
    }
  } catch {
    // ignore
  }
  return out
}

export const syncRecommendedFlagsFromEmailResult = (
  result: any,
  quoteData: any
): any => {
  try {
    const recs: Array<{ planId: string; plan?: any }> =
      (result as any)?.agentRecommendedPlans || []
    if (Array.isArray(recs) && recs.length > 0) {
      const ids = new Set(
        recs
          .map((r) => r?.planId || r?.plan?.planId || r?.plan?.id)
          .filter(Boolean)
      )
      if (quoteData) {
        const vision = Array.isArray((quoteData as any).individualPlans)
          ? (quoteData as any).individualPlans
          : []
        const dental = Array.isArray((quoteData as any).crossSalePlans)
          ? (quoteData as any).crossSalePlans
          : Array.isArray((quoteData as any).jsonPlans)
            ? (quoteData as any).jsonPlans
            : []
        for (const vp of vision) {
          const vid = (vp as any).id
          if (ids.has(vid)) (vp as any).producerRecommended = 'y'
        }
        for (const dp of dental) {
          const did = (dp as any).planId
          if (ids.has(did)) (dp as any).producerRecommended = 'y'
        }
      }
    }
  } catch {
    // non-blocking sync
  }
  return quoteData
}
